export default __webpack_public_path__ + "static/media/check-true.8abdb635.svg";